import React from 'react';
import { Link } from "react-router-dom";

const ActivityTag = ({ label, path }) => {

    return <Link className="tag" to={ '/topics/' + path + '/' }><span className="green">#</span>{ label }</Link>
}

export default ActivityTag;